import { render, staticRenderFns } from "./AnalyticsSummaryGA4.vue?vue&type=template&id=cfeab422&lang=pug"
import script from "./AnalyticsSummaryGA4.js?vue&type=script&lang=js&external"
export * from "./AnalyticsSummaryGA4.js?vue&type=script&lang=js&external"
import style0 from "./AnalyticsSummary.sass?vue&type=style&index=0&prod&lang=sass&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports